import { useTranslation } from "react-i18next";

export interface CreateTagOptionProps {
  inputValue: string;
}

/**
 * The "create this tag" row shown in the tag picker when the typed value matches no existing tag.
 *
 * The label is one interpolated string rather than a prefix concatenated with the tag name, so
 * translators receive the whole sentence and can place the name where their language needs it.
 */
export const CreateTagOption = ({ inputValue }: CreateTagOptionProps) => {
  const { t } = useTranslation("contacts");

  return <span>{t('Create "{{inputValue}}"', { inputValue })}</span>;
};
